import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Lime = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.89 120.75">
  <G fill={color}>
    <Path d="M73.27,24.77c1.05-2.26,1.58-4.67,1.62-7.09,0-.01,0-.02,0-.03.03-2.08-.31-4.18-1.04-6.19-1.59-4.37-4.79-7.86-9-9.83-8.7-4.05-19.08-.28-23.14,8.42L1.63,95.99c-4.06,8.7-.28,19.08,8.42,23.14h0c2.37,1.11,4.87,1.63,7.33,1.63,6.56,0,12.85-3.72,15.8-10.05l23-49.32s0,0,0,0l17.08-36.61ZM20.34,111.4c-2.15.78-4.48.68-6.55-.29-4.28-2-6.14-7.11-4.15-11.39l8.99-19.28,15.53,7.24-8.99,19.28c-.97,2.07-2.68,3.65-4.84,4.43ZM61.11,9.64c2.07.97,3.65,2.69,4.43,4.84,0,.02,0,.04.01.06l-19.49,7.09,3.66-7.84c2-4.28,7.11-6.14,11.39-4.15ZM48.95,55.99l-22.78,8.29,4.79-10.26,22.78-8.29-4.79,10.26ZM37.91,79.68l-12.36-5.76,18.12-6.59-5.76,12.36ZM59.03,34.4l-22.78,8.29,4.54-9.74s.1-.02.15-.04l22.62-8.23-4.54,9.73Z"/>
  </G>
</Svg>
);
};

export default Lime;
